import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useI18n = (localI18n) => {
    const i18n = useSelector((state) => state.i18n.translations),
        locale = useLocale();
    return useMemo(() => {
        return {
            ...i18n,
            ...(localI18n ? localI18n[locale] : {}),
        };
    }, [localI18n, i18n, locale]);
};

export function useLocalI18n(strings, locale = useLocale()) {
    return useMemo(
        () => (locale in strings ? strings[locale] : strings['en']),
        [locale, strings]
    );
}


export const selectLocate = (state) => state.i18n.locale;

export const useLocale = () => {
    return useSelector(selectLocate);
};
